import { Button, Grid } from "@mui/material";

export default function SquareButton(props) {
  const { name, value, icon, onClick, height, width } = props;

  const handleButtonClick = () => {
    onClick(value);
  };

  return (
    <Button
      variant="contained"
      onClick={handleButtonClick}
      size="small"
      sx={{ height: height || 100, width: width || 100 }}
    >
      <Grid container direction="column" justifyContent="center">
        <Grid item>{icon}</Grid>
        <Grid item>{name}</Grid>
      </Grid>
    </Button>
  );
}
